import React from 'react';
import QuoteFormSection from '../components/QuoteFormSection';

export default function DevisPage() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--hr-bg)' }}>
      
      {/* Hero */}
      <section className="py-16 sm:py-20" style={{ backgroundColor: 'var(--hr-bg-alt)' }}>
        <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <h1 
            className="font-['Playfair_Display'] text-4xl sm:text-5xl font-bold"
            style={{ color: 'var(--hr-text)' }}
          >
            Recevez votre devis cadré
          </h1>
          <p 
            className="text-xl leading-relaxed"
            style={{ color: 'var(--hr-text-muted)' }}
          >
            En 3 étapes simples, décrivez votre projet. Nous reviendrons vers vous avec un plan clair et un chiffrage détaillé.
          </p>
          <div className="flex items-center justify-center gap-8 pt-6">
            {[
              { icon: '✓', text: 'Sans engagement' },
              { icon: '✓', text: 'Réponse sous 48h' },
              { icon: '✓', text: 'Devis détaillé' }
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2">
                <span className="font-bold text-lg" style={{ color: 'var(--hr-success)' }}>{item.icon}</span>
                <span className="text-sm font-medium" style={{ color: 'var(--hr-text)' }}>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Form */}
      <section className="py-12 sm:py-16">
        <div className="max-w-[1160px] mx-auto px-4 sm:px-6 lg:px-8">
          <QuoteFormSection />
        </div>
      </section>
    </div>
  );
}